module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#play",
      toString: function () {
        return this.url;
      }
    }